import $axios from 'src/utils/axios';

export const GetUserSubscription = ({ page = 1, per_page = 10, search_term = '' }) => {
  return $axios.get(`pricing/subscription/list?page=${page}&per_page=${per_page}&search=${search_term}`);
};
export const GetSubscriptionDetails = ({ page = 1, per_page = 10, search_term = '' }) => {
  return $axios.get(`pricing/history/list?page=${page}&per_page=${per_page}&search=${search_term}`);
};

export const GetApprovalDashboard = () => {
  return $axios.get('/pricing/company/dashboard');
};
export const GetApprovalDashboardDetails = () => {
  return $axios.get('/pricing/company/dashboard/details');
};

export const GetApprovalList = ({ page = 1, per_page = 10, search = '', status = 0 }) => {
  return $axios.get(`pricing/request/list?page=${page}&per_page=${per_page}&search=${search}&status=${status}`);
};

export const PostApprovalRequest = (data) => {
  return $axios.post('pricing/request/approve', data);
};

export const RequestCredit = (data) => {
  return $axios.post('pricing/request/create', { data });
};

export const SubscriptionRequest = () => {
  const data = {
    subscription_category_id: 1,
  };
  return $axios.post('pricing/subscription/create', data);
};

export const PaymentRequest = (data) => {
  return $axios.post('payment/checkout/create', { data: data });
};

export const GetDisbursementUser = () => {
  return $axios.get('/pricing/get-users');
};

export const DisburseCredit = (data) => {
  return $axios.post('/pricing/credit-disburse', data)
}

export const PaymentRefValidation = (data) => {
 return $axios.post('payment/check/reference_number', data);
}

export const PurchaseHistoryRequest = ({ page = 1, per_page = 10}) => {
  return $axios.get(`pricing/credit/history/list?page=${page}&per_page=${per_page}`);
};
